module.exports = __webpack_public_path__ + "static/FunktionalGrotesk-Light-638c9b527d4161eee75af75c62dbc0b9.woff2";